import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import MenuItems from './MenuItems';
import MobileMenu from './MobileMenu';
// import SearchPopup from './SearchPopup';
// import navImg from "../../../assets/images/resources/logo-1.png";
import navImg from "../../../assets/images/resources/SCLOGO.png";

const Header = (props) => {
    const { parentMenu, secondParentMenu, activeMenu } = props;
    const [isVisible, setIsVisible] = useState(false);
    const [isMobileMenu, setMobileMenu] = useState(false);
    const [isPopup, setIsPopup] = useState(false);
    const [isSidebar, setIsSidebar] = useState(false);

    const handleMobileMenu = () => {
        setMobileMenu(!isMobileMenu);
        if (!isMobileMenu) {
            document.body.classList.add("mobile-menu-visible");
        } else {
            document.body.classList.remove("mobile-menu-visible");
        }
    }

    const handlePopup = () => {
        setIsPopup(!isPopup);
    }

    const handleSidebar = () => {
        setIsSidebar(!isSidebar);
    }

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > 100) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener("scroll", toggleVisibility);

        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    return (
        <React.Fragment>
            <header className={`main-header ${isVisible ? "fixed-header" : ""}`}>
                <nav className="main-menu">
                    <div className="main-menu__wrapper">
                        <div className="container">
                            <div className="main-menu__wrapper-inner">
                                <div className="main-menu__left">
                                    <div className="main-menu__logo">
                                        <Link to="/">
                                            <img
                                                src={navImg}
                                                alt="Logo"
                                                style={{ width: "70px", height: "80px" }}
                                            />
                                        </Link>
                                    </div>
                                    <div className="mobile-nav__toggler" onClick={handleMobileMenu}>
                                        <i className="fa fa-bars" />
                                    </div>
                                </div>
                                <div className="main-menu__center">
                                    <ul className="flex items-center justify-center main-menu__list">
                                        <MenuItems
                                            parentMenu={parentMenu}
                                            secondParentMenu={secondParentMenu}
                                            activeMenu={activeMenu}
                                        />
                                    </ul>
                                </div>
                                <div className="main-menu__right">
                                    <div className="main-menu__search-nav-sidebar-btn-box">
                                        <div className="main-menu__btn-box">
                                            <a href="https://api.whatsapp.com/send?phone=919983333188&text=Hello%20Sunrising%20Cinevision%20Academy%2C%0AI%20hope%20you%27re%20doing%20well!%20I%20just%20wanted%20to%20reach%20out%20and%20connect.%20Looking%20forward%20to%20hearing%20from%20you" target="_blank" rel="noopener noreferrer" className="thm-btn main-menu__btn" style={{ color: '#fff', textDecoration: 'none', display: 'block' }}>
                                                Get In Touch
                                                <span />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>

                <div className={`stricky-header stricked-menu main-menu ${isVisible ? "stricky-fixed" : ""}`}>
                    <div className="sticky-header__content" />
                    <nav className="main-menu">
                        <div className="main-menu__wrapper">
                            <div className="container">
                                <div className="main-menu__wrapper-inner">
                                    <div className="main-menu__left">
                                        <div className="main-menu__logo">
                                            <Link to="/">
                                                <img src={navImg} alt="Logo" style={{ width: "70px", height: "80px" }} />
                                            </Link>
                                        </div>
                                        <div className="mobile-nav__toggler" onClick={handleMobileMenu}>
                                            <i className="fa fa-bars" />
                                        </div>
                                    </div>
                                    <div className="main-menu__center">
                                        <ul className="main-menu__list">
                                            <MenuItems
                                                parentMenu={parentMenu}
                                                secondParentMenu={secondParentMenu}
                                                activeMenu={activeMenu}
                                            />
                                        </ul>
                                    </div>
                                    <div className="main-menu__right">
                                        <div className="main-menu__search-nav-sidebar-btn-box">
                                            <div className="main-menu__btn-box">
                                                <a href="https://api.whatsapp.com/send?phone=919983333188&text=Hello%20Sunrising%20Cinevision%20Academy%2C%0AI%20hope%20you%27re%20doing%20well!%20I%20just%20wanted%20to%20reach%20out%20and%20connect.%20Looking%20forward%20to%20hearing%20from%20you" target="_blank" rel="noopener noreferrer" className="thm-btn main-menu__btn" style={{ color: '#fff', textDecoration: 'none', display: 'block' }}>
                                                    Get In Touch
                                                    <span />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>

                <MobileMenu handleMobileMenu={handleMobileMenu} />
            </header>
            {/* <SearchPopup isPopup={isPopup} handlePopup={handlePopup} /> */}
        </React.Fragment>
    );
}

export default Header;
